module.exports = __webpack_public_path__ + "static/img/cicon53.548fb4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/connect/cicon53.png
// module id = e3T5
// module chunks = 7